<div class="row-scope" [ngClass]="{ 'drag-handle': rowVm.selected }">
  @if (rowVm.selected) {
    <div class="selected-item-border"></div>
  }
  <div class="column">
    <span class="column-t">{{ rowVm.order }}</span>
    @if (rowVm.selected) {
      <img src="assets/img/move_icon.png" class="drag-icon" alt="logo" />
    }
  </div>
  <div class="desc-sc">
    <span class="desc-t">{{ rowVm.label }}</span>
  </div>
</div>
